<template>
  <div class="container">
    <loader
      :show="
        showLoader &&
        !isHomePage &&
        !isHistoryPage &&
        !isSendIndicationsPage &&
        !isSettingsPage &&
        !isCalculatorPage &&
        !isFeedbackPage &&
        !autoLoginPending &&
        !(isAccountsListPage && !$route.query.newAccount) &&
        !isAddAccountPage &&
        !isNoComissionPay
      "
      :text="loaderText"
    />
    <template v-if="autoLoginPending && !hasCachedAccounts">
      <div class="splash-screen">
        <div class="splash-logo-container">
          <img
            src="@/assets/images/zakarp_energo.png"
            class="splash-logo"
            alt="Закарпаття Енерго"
          />
          <div class="loading-animation">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p
            class="loading-npm i -D vue-loader@15.10.1 @babel/core core-jstext"
          >
            {{ $t("global.loading") }}
          </p>
        </div>
      </div>
    </template>
    <template v-else-if="nativeData && nativeData.agreement === false">
      <div
        class="itserve-center p-25"
        style="background-color: #1d1d1d; height: 100%"
      >
        <img
          src="@/assets/images/zakarp_energo.png"
          width="200"
          style="border-radius: 50%"
          class="company-logo m-t-10"
        />
        <div class="itserve-center mt-25 pb-25">
          <p>
            <label style="color: #cccccc">{{ $t("oferta.accept_info") }}</label>
          </p>
          <p>
            <label style="color: #cccccc">{{
              $t("oferta.accept_info1")
            }}</label>
          </p>
          <p>
            <label style="color: #cccccc">{{
              $t("oferta.accept_info2")
            }}</label>
          </p>
        </div>
        <p>
          <label
            style="color: #cccccc; text-decoration: underline"
            @click="ofertaPage"
            >{{ $t("oferta.oferta") }}</label
          >
        </p>
        <p>
          <label
            style="color: #cccccc; text-decoration: underline"
            @click="policyPage"
            >{{ $t("oferta.policy") }}</label
          >
        </p>
        <itserve-button
          :value="this.$t('buttons.confirm')"
          type="primary"
          @click="confirm"
          class="mt-15 apply-loader"
          style="color: #cccccc"
        ></itserve-button>
      </div>
    </template>
    <template v-else-if="hiddenContent === true">
      <app-content />
    </template>
    <template
      v-else-if="
        guestMode === 1 &&
        nativeData &&
        (nativeData.google_id_token === undefined ||
          nativeData.google_id_token.length === 0) &&
        (nativeData.apple_user_id === undefined ||
          nativeData.apple_user_id.length === 0) &&
        !hasCachedAccounts
      "
    >
      <AutorizationPage />
    </template>
    <template v-else-if="isPhoneLoaded && !getPhone">
      <add-phone></add-phone>
    </template>
    <template
      v-else-if="
        (authToken !== null && authToken !== undefined) || hasCachedAccounts
      "
    >
      <app-header />
      <app-content />
      <!--                  <div class="notoken-box itserve-center">-->
      <!--                    {{ nativeData }}-->
      <!--                  </div>-->
      <template v-if="showFooter">
        <app-footer />
      </template>
    </template>
    <template v-else>
      <div
        class="itserve-center"
        style="background-color: #1d1d1d; height: 100%"
      >
        <img
          src="@/assets/images/zakarp_energo.png"
          class="company-logo m-t-10"
          style="padding-top: 45%; border-radius: 50%"
        />
      </div>
    </template>
  </div>
</template>
<script>
import appBridge from "@/mixins/app-bridge";
import AppHeader from "@/components/template/AppHeader";
import AppFooter from "@/components/template/AppFooter";
import AppContent from "@/components/template/AppContent";
import goBack from "@/mixins/go-back";
import Loader from "@/components/content/Loader";
import ItserveButton from "@/components/forms/ItserveButton";
import { mapGetters } from "vuex";
import AutorizationPage from "@/views/autorization/AutorizationPage";
// import ItserveRoute from "@/components/content/ItserveRoute";
import addPhone from "@/components/popup/addPhone";

const PAYMENT_FLOW_SESSION_KEY = "paymentFlowInProgress";
const PAYMENT_FLOW_TTL_MS = 15 * 60 * 1000;

export default {
  name: "App",
  components: {
    AutorizationPage,
    // ItserveRoute,
    Loader,
    AppHeader,
    AppFooter,
    AppContent,
    ItserveButton,
    addPhone,
  },
  data() {
    return {
      showFooter: true,
      autoLoginPending: true,
      initialDataLoaded: false,
      hasCachedAccounts: false,
    };
  },
  mixins: [appBridge, goBack],
  beforeMount() {
    document.body.classList.add("app-theme-dark");

    // Проверка целостности данных в localStorage
    this.validateLocalStorage();
  },

  created() {
    // При запуске приложения сбрасываем флаг app_started
    // чтобы при каждом запуске приложения происходил запрос bills
    sessionStorage.removeItem("app_started");

    // Проверяем, есть ли сохраненные данные для быстрого запуска
    let accounts = localStorage.getItem("accounts");
    let authToken = localStorage.getItem("authToken");

    // Сначала проверяем наличие счетов и токена
    const hasAccountsAndToken = Boolean(
      accounts && authToken && accounts !== "{}" && accounts !== "[]"
    );

    // Если есть счета и токен, но нет выбранного счета, создаем заглушку
    if (hasAccountsAndToken && !localStorage.getItem("lastAccount")) {
      console.log("Есть счета, но нет выбранного счета. Создаю заглушку...");
      try {
        // Парсим счета и берем первый счет для заглушки
        const parsedAccounts = JSON.parse(accounts);
        let firstAccount;
        // Определяем, является ли accounts массивом или объектом
        if (Array.isArray(parsedAccounts) && parsedAccounts.length > 0) {
          firstAccount = parsedAccounts[0];
        } else if (
          typeof parsedAccounts === "object" &&
          Object.keys(parsedAccounts).length > 0
        ) {
          firstAccount = parsedAccounts[Object.keys(parsedAccounts)[0]];
        }

        if (firstAccount) {
          // Записываем первый счет как заглушку lastAccount
          localStorage.setItem("lastAccount", JSON.stringify(firstAccount));
          console.log(
            "Создана заглушка lastAccount из первого счета:",
            firstAccount
          );
        }
      } catch (e) {
        console.error("Ошибка при создании заглушки lastAccount:", e);
      }
    }

    // Теперь проверяем наличие всех данных после создания заглушки
    const lastAccount = localStorage.getItem("lastAccount");
    this.hasCachedAccounts = Boolean(accounts && lastAccount && authToken);

    console.log("Проверка наличия данных в localStorage:", {
      hasCachedAccounts: this.hasCachedAccounts,
      hasAccounts: Boolean(accounts),
      hasLastAccount: Boolean(lastAccount),
      hasAuthToken: Boolean(authToken),
    });

    // Проверяем флаг, показывающий, что нужно открыть список счетов
    const showAccountsList =
      localStorage.getItem("show_accounts_on_next_launch") === "true";
    const paymentFlowInProgress = this.isPaymentFlowInProgress();
    if (showAccountsList) {
      console.log("Обнаружен флаг показа списка счетов, удаляю его");
      localStorage.removeItem("show_accounts_on_next_launch");
    }

    // Если есть кешированные данные, сразу отображаем список счетов
    if (this.hasCachedAccounts) {
      console.log(
        "Найдены сохраненные данные, сразу переходим к списку счетов..."
      );
      // Сразу переключаемся на список счетов, не ждем загрузку
      this.autoLoginPending = false;
      this.initialDataLoaded = true;

      // Переходим на список счетов
      // Если флаг show_accounts_on_next_launch установлен или мы не на странице с правильным маршрутом
      const nonRedirectRoutes = ["AccountsListPage"];
      if (
        !paymentFlowInProgress &&
        (showAccountsList || !nonRedirectRoutes.includes(this.$route.name))
      ) {
        console.log("Переходим на список счетов");
        // Всегда переходим на список счетов при следующем запуске
        this.$router.replace({ name: "AccountsListPage" });
      }
    }

    // Автоматический вход при запуске приложения
    if (!this.hasCachedAccounts) {
      // Если нет кешированных данных, только тогда запускаем вход
      console.log("Нет кешированных данных, выполняю стандартный вход");
      this.$store.dispatch("Auth/tryAutoLogin").finally(() => {
        this.autoLoginPending = false;
        this.initialDataLoaded = true;
      });
    } else {
      // Если есть кешированные данные, всё равно запускаем трайАвтоЛогин
      console.log(
        "Уже есть кешированные данные, но запускаю tryAutoLogin для проверки обновлений"
      );
      this.$store.dispatch("Auth/tryAutoLogin").finally(() => {
        this.autoLoginPending = false;
        this.initialDataLoaded = true;
      });
    }

    this.nativeWaitForEvent("authToken", (authData) => {
      this.$store.dispatch("Auth/authenticate", authData);
    });
    this.nativeWaitForEvent("authTokenListen", (authData) => {
      this.$store.dispatch("Auth/authenticate", authData);
      this.$store.dispatch("Auth/newGoogleAuth");
    });

    // let authData = {
    //   uid: "LrMjo6sPiebz4V7SGV9B1zGSAhD2",
    //   firebase_token:
    //     "epIJQeeRrEqQiLW6kH-0LK:APA91bGIB375gUuf1YhucWHXWBeP_QaSyjxX9mCJueByhF1fAtOrmjfWlFEu4qcwzEb7KYfdv0YPhHtL3fLkZzf0W12KtP2ZY-QUoV6JUSMgoqtr_a42QLi6zoltyn3EXO_q1oQjc1Gq",
    //   themeMode: "ns-dark",
    //   lang: "en",
    //   google_id_token: "",
    //   google_access_token: "",
    //   platform: "ios",
    //   apple_user_id: "",
    //   agreement: true,
    //   facebook_installed: true,
    // };
    // this.$store.dispatch("Auth/authenticate", authData);

    this.nativeWaitForEvent("backButton", () => {
      if (
        this.$route.name === "Home" ||
        this.$route.name === "AccountsListPage"
      ) {
        this.nativeSendEvent("setPageLevel", { level: 0 });
      } else {
        this.nativeSendEvent("setPageLevel", { level: 1 });
        this.goBack();
      }
    });
    this.nativeWaitForEvent("deepLink", (deepLinkData) => {
      if (this.shouldIgnoreDeepLinkDuringPayment(deepLinkData)) {
        return;
      }
      this.$router.push(deepLinkData);
    });

    this.nativeWaitForEvent("resume", () => {
      if (this.isPaymentFlowInProgress()) {
        return;
      }
      console.log("Приложение возобновлено");
      // Только переходим на страницу списка счетов, без дополнительных запросов
      if (this.$route.name !== "AccountsListPage") {
        this.$router.replace({ name: "AccountsListPage" });
      }
    });
    this.nativeWaitForEvent("appCollapsed", () => {
      if (this.isPaymentFlowInProgress()) {
        this.nativeSendEvent("disableFlashlight");
        return;
      }
      // При сворачивании приложения сохраняем флаг, чтобы при следующем открытии показать список счетов
      console.log(
        "Приложение свернуто, устанавливаю флаг показа списка счетов при следующем запуске"
      );
      localStorage.setItem("show_accounts_on_next_launch", "true");
      this.nativeSendEvent("disableFlashlight");
    });

    this.$router.afterEach((to) => {
      this.showFooter = to.name !== "EasyPayAllServicePage";
    });
  },
  computed: {
    ...mapGetters("Auth", ["nativeData"]),
    showLoader() {
      return this.$store.state.Api.loading;
    },
    loaderText() {
      // Показываем текст "Зачекайте, йде додавання рахунку" когда добавляется новый счет
      if (this.isAccountsListPage && this.$route.query.newAccount) {
        return this.$t("addAccount.addingInProgress");
      }
      return "";
    },
    isNoComissionPay() {
      return this.$route.name === "NoComissionPay";
    },
    isHomePage() {
      return this.$route.name === "Home";
    },
    isAccountsListPage() {
      return this.$route.name === "AccountsListPage";
    },
    isAddAccountPage() {
      return this.$route.name === "AddAccount";
    },
    isHistoryPage() {
      const historyRoutes = ["IndicationsHistory", "PaymentHistory"];
      return historyRoutes.includes(this.$route.name);
    },
    isSendIndicationsPage() {
      return this.$route.name === "SendIndications";
    },
    isSettingsPage() {
      const settingsRoutes = [
        "Settings",
        "Index",
        "PaymentCards",
        "StripePayment",
      ];
      return settingsRoutes.includes(this.$route.name);
    },
    isCalculatorPage() {
      const calculatorRoutes = ["CalculationPage", "SelectMeterage"];
      return calculatorRoutes.includes(this.$route.name);
    },
    isFeedbackPage() {
      const feedbackRoutes = ["WriteTicket", "AppSupport", "Contacts"];
      return feedbackRoutes.includes(this.$route.name);
    },
    flashlightEnabled() {
      return this.$store.state.Flashlight.flashlightEnabled;
    },
    locale() {
      return this.$store.state.Auth.locale;
    },
    appTheme() {
      return this.$store.state.Auth.appTheme;
    },
    authToken() {
      console.log("CHLENIX authToken: " + this.$store.state.Auth.authToken);
      return this.$store.state.Auth.authToken;
    },
    nativeData() {
      return this.$store.state.Auth.nativeData;
    },
    guestMode() {
      return this.$store.state.Auth.guest;
    },
    hiddenContent() {
      return this.$store.state.Auth.hidden;
    },
    getPhone() {
      console.log("getPhone CHLENIX " + this.$store.state.Auth.phoneNumber);
      return this.$store.state.Auth.phoneNumber;
    },
    isPhoneLoaded() {
      return this.$store.state.Auth.phoneLoaded;
    },
  },
  watch: {
    authToken() {
      this.$store.dispatch("Auth/getGuest");
      this.$store.dispatch("Auth/setupUserSettings");
    },
    initialDataLoaded(newVal) {
      if (newVal && this.authToken) {
        // Когда данные загружены и есть токен, проверяем нужно ли перенаправление
        // на страницу счетов, если мы не на главной и не на списке счетов
        const currentRoute = this.$route.name;
        const accountsExist =
          this.$store.state.Auth.accounts &&
          Object.keys(this.$store.state.Auth.accounts).length > 0;

        if (
          !this.isPaymentFlowInProgress() &&
          accountsExist &&
          currentRoute !== "Home" &&
          currentRoute !== "AccountsListPage" &&
          currentRoute !== "AddAccount"
        ) {
          console.log(
            "Перенаправляем на список счетов, так как данные загружены"
          );
          this.$router.replace({ name: "AccountsListPage" });
        }
      }
    },
    locale(newLocale) {
      this.$i18n.locale = newLocale;
    },
  },
  methods: {
    isPaymentFlowInProgress() {
      const startedAt =
        Number(sessionStorage.getItem(PAYMENT_FLOW_SESSION_KEY)) ||
        Number(localStorage.getItem(PAYMENT_FLOW_SESSION_KEY));
      const expiresAt = Number(
        localStorage.getItem(`${PAYMENT_FLOW_SESSION_KEY}ExpiresAt`)
      );

      if (!startedAt) {
        return false;
      }

      if (expiresAt && Date.now() > expiresAt) {
        sessionStorage.removeItem(PAYMENT_FLOW_SESSION_KEY);
        localStorage.removeItem(PAYMENT_FLOW_SESSION_KEY);
        localStorage.removeItem(`${PAYMENT_FLOW_SESSION_KEY}ExpiresAt`);
        return false;
      }

      return Date.now() - startedAt < PAYMENT_FLOW_TTL_MS;
    },

    shouldIgnoreDeepLinkDuringPayment(deepLinkData) {
      if (!this.isPaymentFlowInProgress()) {
        return false;
      }

      const targetName =
        typeof deepLinkData === "string" ? deepLinkData : deepLinkData?.name;
      const targetPath =
        typeof deepLinkData === "string" ? deepLinkData : deepLinkData?.path;

      return (
        !targetName ||
        targetName === "AccountsListPage" ||
        targetPath === "/accounts" ||
        targetPath === "/home"
      );
    },

    validateLocalStorage() {
      try {
        // Проверяем все записи в localStorage
        const keys = [
          "accounts",
          "lastAccount",
          "authToken",
          "userCredentials",
        ];
        let hasErrors = false;

        keys.forEach((key) => {
          try {
            const item = localStorage.getItem(key);
            if (key !== "authToken" && item) {
              // Если это JSON, пробуем его разобрать
              JSON.parse(item);
            }
          } catch (e) {
            console.error(`Ошибка при разборе ${key} в localStorage:`, e);
            localStorage.removeItem(key); // Удаляем поврежденные данные
            hasErrors = true;
          }
        });

        // Если есть ошибки, логируем
        if (hasErrors) {
          console.warn(
            "Найдены ошибки в localStorage, сброшены поврежденные данные"
          );
        }
      } catch (e) {
        console.error("Ошибка при проверке localStorage:", e);
      }
    },

    async clearForGoogleAuth({ commit }) {
      await commit("Auth/SET_NATIVE_DATA", null);
    },
    confirm() {
      this.nativeSendEvent("confirmAgreenment", true);
      this.$store.state.Auth.nativeData.agreement = true;
      this.$store.commit("Settings/AGREEMENT", false);
    },
    googleSign() {
      this.nativeSendEvent("googleSignin");
    },
    appleSign() {
      this.nativeSendEvent("appleSignin");
    },
    ofertaPage() {
      this.$store.commit("Auth/SET_HIDDEN", true);
      this.$store.state.Auth.nativeData.agreement = true;
      this.$store.commit("Settings/AGREEMENT", true);
      this.$router.push({
        name: "OfertaPage",
        params: this.$route.params,
      });
    },
    policyPage() {
      this.$store.commit("Auth/SET_HIDDEN", true);
      this.$store.state.Auth.nativeData.agreement = true;
      this.$store.commit("Settings/AGREEMENT", true);
      this.$router.push({
        name: "PolicyPage",
        params: this.$route.params,
      });
    },
  },
};
</script>
<style>
@import "assets/template.scss";
@import "assets/app.scss";
@import "assets/media.scss";

/* Новые стили для экрана загрузки */
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0e121c;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.splash-logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.splash-logo {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  margin-bottom: 30px;
  animation: pulse 2s infinite;
  box-shadow: 0 0 30px rgba(52, 152, 219, 0.5);
}

.loading-text {
  color: #ffffff;
  font-size: 18px;
  margin-top: 20px;
  font-weight: 500;
}

.loading-animation {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.loading-animation span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background: #3498db;
  border-radius: 50%;
  animation: loading 1.5s infinite ease-in-out both;
}

.loading-animation span:nth-child(1) {
  animation-delay: 0s;
}

.loading-animation span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-animation span:nth-child(3) {
  animation-delay: 0.4s;
}

.loading-animation span:nth-child(4) {
  animation-delay: 0.6s;
}

.loading-animation span:nth-child(5) {
  animation-delay: 0.8s;
}

@keyframes loading {
  0%,
  100% {
    transform: scale(0.3);
    opacity: 0.2;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 15px rgba(52, 152, 219, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);
  }
}

.notoken-box {
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  background-color: #ffffff;
  padding-top: 25px;
}
.container_width {
  width: 337px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 15px 15px 15px 15px;
}
</style>
